export enum ShutDownErrorCode {
    RoomFull = 60010,
}